/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Whitelabel_CountInputs */

const en_pricing_feature_whitelabel_count = /** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Whitelabel Sites`)
};

const es_pricing_feature_whitelabel_count = /** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Sitios de Marca Blanca`)
};

const fr_pricing_feature_whitelabel_count = /** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 sites en marque blanche`)
};

const de_pricing_feature_whitelabel_count = /** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Whitelabel-Sites`)
};

const id_pricing_feature_whitelabel_count = /** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Situs Whitelabel`)
};

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const ja_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const zh_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const ar_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const it_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const ru_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const pt_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/** @type {(inputs: Pricing_Feature_Whitelabel_CountInputs) => LocalizedString} */
const ko_pricing_feature_whitelabel_count = en_pricing_feature_whitelabel_count;

/**
* | output |
* | --- |
* | "5 Whitelabel Sites" |
*
* @param {Pricing_Feature_Whitelabel_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_whitelabel_count = /** @type {((inputs?: Pricing_Feature_Whitelabel_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Whitelabel_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_whitelabel_count(inputs)
	if (locale === "es") return es_pricing_feature_whitelabel_count(inputs)
	if (locale === "fr") return fr_pricing_feature_whitelabel_count(inputs)
	if (locale === "de") return de_pricing_feature_whitelabel_count(inputs)
	if (locale === "ja") return ja_pricing_feature_whitelabel_count(inputs)
	if (locale === "zh") return zh_pricing_feature_whitelabel_count(inputs)
	if (locale === "ar") return ar_pricing_feature_whitelabel_count(inputs)
	if (locale === "id") return id_pricing_feature_whitelabel_count(inputs)
	if (locale === "it") return it_pricing_feature_whitelabel_count(inputs)
	if (locale === "ru") return ru_pricing_feature_whitelabel_count(inputs)
	if (locale === "pt") return pt_pricing_feature_whitelabel_count(inputs)
	return ko_pricing_feature_whitelabel_count(inputs)
});